<template>
    <div class="basket">
        <h1 class="def-title-2">{{ messages.title }}</h1>
        <p class="basket__description" v-if="items.length > 0">{{ messages.orderDescription }}</p>
        <div class="basket__grid">
            <PerfectScrollbar v-if="items.length > 0" class="basket__items">
                <BasketCard
                    v-for="item in items"
                    :result="item"
                    :dataLayer="dataLayer"
                    :key="item.id"
                    @update="update"
                    @removeFromBasket="removeFromBasket"
                />
            </PerfectScrollbar>
            <div v-else-if="messages">
                {{ messages.noItems }}
            </div>
            <div v-if="items.length > 0" class="basket-aside">
                <div class="basket-aside__block">
                    <OrderTotal/>
                    <a :href="routes.createOrder.path" class="def-button basket-aside__to-order">
                        {{ messages.orderConfirm }}
                    </a>
                </div>
                <!--
                <div class="basket-aside__block">
                    <buy-one-click :result="obData" />
                </div>
                -->
            </div>
        </div>
        <quick-view-form
            v-if="items.length > 0"
            :intoBasket="true"
            :product="items"
            :messages="messages"
            @close="$emit('close')"
        />
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'Basket',
    computed: {
        ...mapState({
            messages: ({basket}) => basket.data.messages,
            items: ({basket}) => basket.data.items,
            dataLayer: ({basket}) => basket.data.dataLayer,
            routes: ({basket}) => basket.data.routes,
        }),
    },
    methods: {
        update(id, count) {
            try {
                if (window.smallBasket) {
                    /** если есть малая корзина обновляем товары из неё **/
                    window.smallBasket.update(id, count);
                } else {

                    $.ajax({
                        debug: App.debug,
                        url: this.obData.routs.update.path,
                        method: this.obData.routs.update.method,
                        data: {
                            action: this.obData.routs.update['params-example-data'].action,
                            id,
                            count
                        },
                        success: (data) => {
                            this.obData = {
                                ...this.obData,
                                ...data
                            }
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            if (this.debug) console.log(thrownError);
                        }
                    });
                }
            } catch (err) {
                console.error(err);
            }
            console.log(id, count);
        },
        removeFromBasket(id) {
            try {
                /** если есть малая корзина удаляем товары из неё **/
                if (window.smallBasket) {
                    let itemBasket = {};
                    if (this.obData.items) {
                        this.obData.items.forEach(function (item, i, arr) {
                            let tempId = item.id;
                            if (item.offer && item.offer.id) {
                                tempId = item.offer.id;
                            }
                            if (tempId == id) {
                                itemBasket = item;
                            }
                        });
                    }


                    window.smallBasket.removeFromBasket(itemBasket);
                } else {
                    $.ajax({
                        debug: App.debug,
                        url: this.obData.routs.remove.path,
                        method: this.obData.routs.remove.post,
                        data: {
                            action: this.obData.routs.remove['params-example-data'].action,
                            id: id
                        },
                        success: (data) => {

                            // this.obData.items = data.items || [];
                            // // this.obData.price = data.price;
                            // this.$set(this.obData, 'price', data.price);
                            this.obData = {
                                ...this.obData,
                                ...data,

                            }
                            console.log(data);
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            if (this.debug) console.log(thrownError);
                        }
                    });

                }
            } catch (err) {
                console.error(err);
            }
        },
    },
    mounted() {
        /** вешаем обработчик события для слежения изменений данных в малой корзине **/
        if (window.smallBasket) {
            window.smallBasket.$on('changeData', data => {
                this.obData.items = data.items;
                this.obData.price = data.price;
                // console.log(data);
            });
        }
    },
}
</script>

<style lang="scss">
.basket {
    padding-top: 16px;
    margin-bottom: 80px;
    @include point-lg{
        padding-top: 24px;
    }
    .def-title-2 {
        margin-bottom: 4px;
    }

    &__description {
        font-size: rem(16);
        line-height: 110%;
        color: #757575;
        margin-bottom: 16px;
        @include point-md {
            margin-bottom: 24px;
        }
    }

    &__grid {
        display: flex;
        flex-direction: column;
        @include point-md {
            display: grid;
            grid-template-columns: 1fr;
            grid-column-gap: 4px;
        }
        @include point-lg {
            grid-template-columns: 75% 25%;
        }
    }

    &__items {
        max-height: 440px;
        overflow-y: auto;
    }

    .quick-view-form {
        margin-top: 30px;
    }
}
.basket-aside {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    @include point-md {
        flex-direction: row;
        & > * {
            width: calc(50% - 2px);

            &:first-child {
                margin-right: 4px;
            }
        }
    }
    @include point-lg {
        flex-direction: column;
        & > * {
            width: 100%;
        }
    }

    &__block {
        background-color: #fff;
        padding: 24px;
        max-width: 100%;
        width: 100%;
        margin-top: 10px;
        @include point-md {
            width: 50%;
        }
        @include point-lg {
            width: 100%;
            margin: 0;
        }

        &:not(:last-child) {
            margin-bottom: 4px;
        }
    }

    &__to-order.def-button {
        max-width: 100%;
        margin-top: 18px;
        font-size: rem(14);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        width: 100%;
    }
}
</style>